export function taskLabel(task) {
    return task.isHeader ? "header" : "task"
}

export function taskFullLabel(task) {
    return (task?.title ?? "task").titleize()
}
